<mat-card class="shadow-sm p-3" id="subj_srch">
  <h2 class="d-flex align-items-center">Confirm Subject Property</h2>
  <div class="container-fluid px-0 mt-3">
    <div class="row">
      @if (orderState.orderSetting?.draftOrder?.allowPropertySearch !== false) {
        <div class="col-12 col-sm-4 col-xxl-3">
          <app-search-property
            (propertySearch)="onPropertySearch($event)"
            [searchPropertyQuery]="searchPropertyParam"
            [propertySearchOptions]="orderState.orderSetting?.draftOrder?.propertySearchOptions"
          ></app-search-property>
          @if (orderState.orderSetting?.draftOrder?.allowCustomSubject !== false) {
            <div class="mt-3 text-center">
              <p class="m-0">Or</p>
              <button mat-button color="primary" class="mt-2" (click)="triggerCustomPropertyForm()">
                Add Subject Manually
              </button>
            </div>
          }
        </div>
      }

      <div class="property-section col-12 col-sm-8 col-xxl-9">
        <mat-card class="shadow-sm mb-3 border property-detail-section" *ngIf="!openCustomPropertyForm">
          <app-no-content-banner
            *ngIf="!subjectProperty && !searchedPropertyList.length"
            bannerTitle="No Property Selected"
            [bannerSubTitle]="
              orderState.orderSetting?.draftOrder?.allowPropertySearch !== false
                ? 'Search a property via the options available'
                : ''
            "
            class="bg-light"
          />

          @if (searchAttempted && !subjectProperty && !searchedPropertyList.length) {
            <div class="distance-warning mx-3 my-3">
              <mat-icon>warning</mat-icon>
              <span>We could not identify the property. You can still continue if required.</span>
            </div>
            <div class="text-end mb-3 me-3">
              <button type="button" (click)="continueWithUnmatchedProperty()" mat-flat-button color="warn">
                Continue with Unmatched Property
              </button>
            </div>
          }

          <div class="container-fluid" *ngIf="!subjectProperty && searchedPropertyList.length">
            <div class="row">
              <div class="col-12 py-2">
                <h3 *ngIf="searchedPropertyList" class="my-2">Select Subject Property</h3>
                <app-property-table
                  class="select_sub_table"
                  [properties]="searchedPropertyList"
                  [count]="searchCount"
                  (propertySelected)="onPropertySelection($event)"
                />
              </div>
            </div>
          </div>

          @if (subjectProperty) {
            <app-property-description [property]="subjectProperty"></app-property-description>
            @if (hasDistanceError) {
              <div class="distance-warning mx-3 mb-3">
                <mat-icon>warning</mat-icon>
                <span>
                  The identified property is <strong>{{ actualDistanceFt | number }} ft</strong> away from the original
                  order. You may still continue with this property.
                </span>
              </div>
            }
            <div class="text-end mb-3 me-3">
              <button type="button" (click)="onConfirm()" mat-flat-button color="accent">Confirm Property</button>
            </div>
          }
        </mat-card>

        <app-add-custom-property
          class="h-100"
          *ngIf="openCustomPropertyForm"
          (addSubjectManually)="addSubjectManually($event)"
          [isSubject]="true"
        />
      </div>
    </div>
  </div>
</mat-card>
